import React from 'react'
import clsx from 'clsx'
import { Fade, Menu } from '@mui/material'

import Avatar from '../Avatar'
import Card from '../Card'

import useStyles from './styles'

type CardAvatarProps = {
  user: Partial<LocalUser>
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  rootClass?: string
} & Record<string, any>

const CardAvatar: React.FC<CardAvatarProps> = ({
  user,
  onMouseEnter,
  onMouseLeave,
  rootClass,
  ...props
}) => {
  const [open, setOpen] = React.useState(false)
  const [anchor, setAnchor] = React.useState(null)

  const position = React.useMemo(() => {
    const pos = { top: 0, left: 0 }
    if (!anchor) {
      return pos
    }

    const bounds = anchor.getBoundingClientRect()
    pos.top = bounds.bottom + 6
    pos.left = bounds.left + 28

    return pos
  }, [anchor])

  const classes = useStyles()

  const handleClick = React.useCallback(e => {
    e.stopPropagation()
    setAnchor(e.currentTarget)
    setOpen(true)
  }, [])

  const close = React.useCallback(e => {
    e.stopPropagation()
    setAnchor(null)
    setOpen(false)
  }, [])

  const handleMouseEnter = React.useCallback(() => {
    if (onMouseEnter) {
      onMouseEnter()
    }
  }, [onMouseEnter])

  const handleMouseLeave = React.useCallback(() => {
    if (onMouseLeave) {
      onMouseLeave()
    }
  }, [onMouseLeave])

  return (
    <>
      <div
        onClick={handleClick}
        className={clsx(classes.root, rootClass)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* @ts-expect-error Types incorrect */}
        <Avatar user={user} {...props} />
      </div>

      {open && (
        <Menu
          open
          anchorEl={anchor}
          anchorReference={anchor ? 'anchorPosition' : 'anchorEl'}
          anchorPosition={position}
          onClose={close}
          TransitionComponent={Fade}
          classes={{
            paper: classes.menuPaper,
            list: classes.menuList
          }}
        >
          {/* @ts-expect-error Types incorrect */}
          <Card user={user} close={close} />
        </Menu>
      )}
    </>
  )
}

export default React.memo(CardAvatar)
